import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/firebase-functions'
import 'firebase/firebase-storage'

// Initialize Firebase
/* var config = {
  apiKey: "AIzaSyDpkQiirCWun9U--T-FROiQ5Z2SSrBbIL8",
  authDomain: "rimis-sports.firebaseapp.com",
  databaseURL: "https://rimis-sports.firebaseio.com",
  projectId: "rimis-sports",
  storageBucket: "gs://rimis-sports.appspot.com",
  messagingSenderId: "597343755012"
}; */

const config = {
  apiKey: "AIzaSyCIO5jJNolnseGHj9CcEH1VXvajiYdPjK0",
  authDomain: "pwg-kenya.firebaseapp.com",
  databaseURL: "https://pwg-kenya.firebaseio.com",
  projectId: "pwg-kenya",
  storageBucket: "gs://pwg-kenya.appspot.com",
  messagingSenderId: "930714837728",
  appId: "1:930714837728:web:bcb876e29fc231bb2ce685",
  measurementId: "G-JQECYD62ET"
};

/* const config = {
  apiKey: "AIzaSyAbDzCJQqdGq2UeXAcMq9hV5CTO5P5-aSQ",
  authDomain: "pwgkenya.firebaseapp.com",
  databaseURL: "https://pwgkenya.firebaseio.com",
  projectId: "pwgkenya",
  storageBucket: "pwgkenya.appspot.com",
  messagingSenderId: "811259983449",
  appId: "1:811259983449:web:a535bf2cc51fc843"
};  */

firebase.initializeApp(config);
var otherApp = firebase.initializeApp(config, "other");
const auth2 = otherApp.auth();
const db = firebase.firestore();
const auth = firebase.auth();
const functions = firebase.functions();
const storage = firebase.storage();
db.settings({
  timestampsInSnapshots: true
});
export {
  db,
  auth,
  functions,
  auth2,
  storage
}